








































import { LocaleMessage, LocaleMessageObject, TranslateResult } from 'vue-i18n';
import { computed, defineComponent }                           from '@vue/composition-api';
import useGlobalTranslations                                   from '@/hooks/use-global-translations';
import { Computed }                                            from '@/types';
import { useGlobals }                                          from '@/hooks/use-globals';
import cTableHead                                              from './components/table-head.component.vue';
import cTableBody                                              from './components/table-body.component.vue';

export default defineComponent({
  name: 'cTable',
  components: {
    cTableHead,
    cTableBody,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    tableTranslationPath: {
      default: '',
      type: String,
    },
    sortable: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, context) {
    const noData: TranslateResult = useGlobalTranslations('noData');
    const { i18n, router } = useGlobals();
    const localMessages: Computed<any> = computed(() => i18n.getLocaleMessage(i18n.locale));
    const translations: LocaleMessageObject = localMessages.value[ router.currentRoute.name as string ];
    const availableTranslations = translations[ props.tableTranslationPath ] as LocaleMessageObject;
    const getTranslations = (columns: string[]): LocaleMessage[] => columns.map((column: string) => availableTranslations[ column ]);

    const handleSort = (payload: string) => {
      context.emit('handle-sort', payload);
    };
    return {
      slots: context.slots,
      noData,
      getTranslations,
      handleSort,
    };
  },
});
